// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jZy8H","col":"styles_col__J_i7y"};